// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getFirestore } from "firebase/firestore";
import {getAuth} from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAf4v5ATBLujPWeA-OLNZhSvAmsxmuyoOI",
  authDomain: "menulinker-ef1f6.firebaseapp.com",
  projectId: "menulinker-ef1f6",
  storageBucket: "menulinker-ef1f6.firebasestorage.app",
  messagingSenderId: "430931135697",
  appId: "1:430931135697:web:086403d73ef1637248c9f0",
  measurementId: "G-MD4RN8MH6H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);